import {API} from "../../Services";

async function StoreOnlineSendInfo(merchantId,page){
    let token =  localStorage.getItem('token');
    return API.get(`/orders/shipping_time_interval`,{headers: { 'Authorization':  `Bearer ${token}`}});
}

async function StoreOnlineSetSendInfo(uid,description="",sendType,muid){
    let token =  localStorage.getItem('token');
    console.log("OnStore : ",uid)
    return API.put(`/shop/cart/`,{
        shipping_time_interval:uid,
        description:description,
        merchant_uid:muid,
        non_delivery:sendType==="non_delivery"
    },{headers: { 'Authorization':  `Bearer ${token}`}});
}


async function StoreOnlineTimesSendInfo(uid,muid){
    let token =  localStorage.getItem('token');
    console.log("OnStore : ",uid)
    return API.put(`/shop/cart/`,{
        shipping_time_interval:uid,
        merchant_uid:muid
    },{headers: { 'Authorization':  `Bearer ${token}`}});
}


export {StoreOnlineSendInfo,StoreOnlineSetSendInfo,StoreOnlineTimesSendInfo}
